import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, viewChild } from '@angular/core';
import { LoadingBarService } from './loading-bar.service';


@Component({
    selector: 'loading-bar',
    styles: [
        `
        :host {
            z-index: 9999;
            pointer-events: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
        }
        .progress-bar {
            position: relative;
            z-index: 9999;
            top: 0;
            left: 0;
            width: 100%;
            height: 2px;
        }
        .bar {
            width: 100%;
            height: 100%;
            opacity: 0;
            background-color: white;
        }
        @keyframes loading-start {
            from {
                opacity: 1;
                transform: translateX(-100%);
            }
            to {
                opacity: 1;
                transform: translateX(-1%);
            }
        }
        .bar.start {
            animation: loading-start 60s cubic-bezier(0.065, 0.95, 0.05, 0.99);
        }
        @keyframes loading-complete {
            from {
                opacity: var(--complete-from-opacity);
                transform: var(--complete-from-transform);
            }
            to {
                opacity: 0;
                transform: translateX(0);
            }
        }
        .bar.complete {
            animation: loading-complete 250ms ease-out;
        }
        .meteor {
            display: block;
            position: absolute;
            width: 30px;
            height: 100%;
            opacity: 1;
            background-color: white;
            right: 0;
            box-shadow: 3px 0 4px 1px white;
        }
        `
    ],
    host: {
        'role': 'progressbar',
    },
    template: `
        <div class="progress-bar">
            <div
                #bar
                class="bar"
                [class.start]="animState === 'start'"
                [class.complete]="animState === 'complete'"
                [style.--complete-from-opacity]="completeFrom?.opacity"
                [style.--complete-from-transform]="completeFrom?.transform">
                <div class="meteor"></div>
            </div>
        </div>
    `,
})
export class LoadingBarComponent implements OnInit, OnDestroy {

    count = 0;

    constructor(private service: LoadingBarService, private cdr: ChangeDetectorRef) {}

    animState?: 'start' | 'complete';

    completeFrom?: { opacity: string; transform: string };

    private bar = viewChild.required<ElementRef<HTMLElement>>('bar');

    ngOnInit() {
        this.service.register(this);
    }

    start() {
        if (this.count++ === 0) {
            this.animState = undefined;
            this.cdr.detectChanges();
            // flush styles, otherwise a start right after complete continues the running animation instead of restarting it
            this.bar().nativeElement.getBoundingClientRect();
            this.animState = 'start';
            this.cdr.detectChanges();
        }
    }

    complete() {
        if (--this.count <= 0) {
            this.count = 0;
            // a CSS animation cannot continue from where the removed start animation is, so pass its current values
            const { opacity, transform } = getComputedStyle(this.bar().nativeElement);
            this.completeFrom = { opacity, transform };
            this.animState = 'complete';
            this.cdr.detectChanges();
        }
    }

    ngOnDestroy() {
        this.service.unregister(this);
    }
}
